import { LinearProgress, Typography } from "@mui/material";
import { makeStyles } from "@mui/styles";
import React from "react";
import useQueryReadMeOSSContent from "./useReadMeOSSContentHook";

const useStyles = makeStyles(() => ({
  root: {
    width: "100%"
  }
}));

const ThirdPartyNotice: React.FC = () => {
  const classes = useStyles();
  const { data, loading, error } = useQueryReadMeOSSContent();
  const content = data?.configuration?.getReadmeOss?.fileContent ?? "";

  if (loading) {
    return <LinearProgress />;
  }

  if (error || !content) {
    return (
      <Typography>
        The content could not be loaded. Please try again later.
      </Typography>
    );
  }

  return (
    <div
      className={classes.root}
      dangerouslySetInnerHTML={{ __html: content }}
    />
  );
};

export default ThirdPartyNotice;
